/**
 * Hair Extension Product Interactive Functionality
 * Handles shade selection, tooltips, and variant switching
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('🖼️ GALLERY DEBUG: ========================================');
  console.log('🖼️ GALLERY DEBUG: Hair Extension Product JS Initializing');
  console.log('🖼️ GALLERY DEBUG: ========================================');
  
  const shadeOptions = document.querySelectorAll('.shade-option');
  const selectedShadeName = document.querySelector('.selected-shade-name');
  const productImages = document.querySelectorAll('.product-feature-item');
  const navImages = document.querySelectorAll('.slider-nav-item');
  
  console.log('🖼️ GALLERY DEBUG: Found elements:', {
    shadeOptions: shadeOptions.length,
    selectedShadeName: selectedShadeName,
    productImages: productImages.length,
    navImages: navImages.length
  });
  
  console.log('🖼️ GALLERY DEBUG: Product images:', productImages);
  console.log('🖼️ GALLERY DEBUG: Nav images:', navImages);
  
  // Check if images have src
  productImages.forEach((item, index) => {
    const img = item.querySelector('img');
    console.log(`🖼️ GALLERY DEBUG: Product image ${index}:`, {
      element: item,
      img: img,
      src: img ? img.src : 'no img tag',
      display: item.style.display,
      computedDisplay: window.getComputedStyle(item).display,
      variantId: item.dataset.variantId
    });
  });
  
  // Initialize shade selector
  initializeShadeSelector();
  
  // Initialize image slider
  initializeImageSlider();
  
  function initializeShadeSelector() {
    console.log('🖼️ GALLERY DEBUG: initializeShadeSelector called');
    console.log('🖼️ GALLERY DEBUG: Shade options count:', shadeOptions.length);
    
    shadeOptions.forEach((option, index) => {
      console.log(`🖼️ GALLERY DEBUG: Setting up shade option ${index}:`, option.dataset);
      
      // Add tooltip
      addTooltip(option);
      
      // Add click handler
      option.addEventListener('click', function() {
        console.log('🖼️ GALLERY DEBUG: Shade option clicked:', this.dataset.shadeName);
        
        if (this.dataset.unavailable === 'true') {
          console.log('🖼️ GALLERY DEBUG: Shade is unavailable, ignoring click');
          return;
        }
        
        // Remove selected class from all options
        shadeOptions.forEach(opt => opt.classList.remove('selected'));
        
        // Add selected class to clicked option
        this.classList.add('selected');
        
        // Update selected shade name
        const shadeName = this.dataset.shadeName;
        selectedShadeName.textContent = shadeName;
        
        // Switch product images to match variant
        switchToVariant(this.dataset.variantId);
      });
    });
  }
  
  function addTooltip(option) {
    const shadeName = option.dataset.shadeName;
    const tooltip = document.createElement('div');
    tooltip.className = 'shade-tooltip';
    tooltip.textContent = shadeName;
    option.appendChild(tooltip);
  }
  
  function switchToVariant(variantId) {
    console.log('🖼️ GALLERY DEBUG: switchToVariant called with ID:', variantId);
    
    // Hide all product images
    productImages.forEach((img, index) => {
      console.log(`🖼️ GALLERY DEBUG: Hiding image ${index}`);
      img.style.display = 'none';
    });
    
    // Show matching variant image
    const matchingImage = document.querySelector(`[data-variant-id="${variantId}"]`);
    console.log('🖼️ GALLERY DEBUG: Matching image for variant:', matchingImage);
    
    if (matchingImage) {
      matchingImage.style.display = 'block';
      console.log('🖼️ GALLERY DEBUG: ✅ Showed matching image');
    } else {
      console.warn('🖼️ GALLERY DEBUG: ⚠️ No matching image found for variant ID:', variantId);
    }
    
    // Update navigation images
    navImages.forEach(nav => {
      nav.classList.remove('active');
      if (nav.dataset.variantId === variantId) {
        nav.classList.add('active');
      }
    });
  }
  
  function initializeImageSlider() {
    console.log('🖼️ GALLERY DEBUG: ========================================');
    console.log('🖼️ GALLERY DEBUG: initializeImageSlider() called');
    console.log('🖼️ GALLERY DEBUG: jQuery available?', typeof $ !== 'undefined');
    console.log('🖼️ GALLERY DEBUG: Slick available?', typeof $.fn !== 'undefined' ? typeof $.fn.slick : 'jQuery not available');
    
    const mainSlider = document.querySelector('.product-feature-slider');
    const navSlider = document.querySelector('.feature-slider-nav');
    
    console.log('🖼️ GALLERY DEBUG: Main slider element:', mainSlider);
    console.log('🖼️ GALLERY DEBUG: Nav slider element:', navSlider);
    
    // Initialize Slick slider for product images
    if (typeof $ !== 'undefined' && $.fn.slick) {
      console.log('🖼️ GALLERY DEBUG: ✅ Initializing Slick sliders...');
      
      try {
        $('.product-feature-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: '.feature-slider-nav'
        });
        console.log('🖼️ GALLERY DEBUG: ✅ Main slider initialized');
      } catch (e) {
        console.error('🖼️ GALLERY DEBUG: ❌ Failed to initialize main slider:', e);
      }
      
      try {
        $('.feature-slider-nav').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: '.product-feature-slider',
          dots: false,
          centerMode: true,
          focusOnSelect: true,
          arrows: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });
        console.log('🖼️ GALLERY DEBUG: ✅ Nav slider initialized');
      } catch (e) {
        console.error('🖼️ GALLERY DEBUG: ❌ Failed to initialize nav slider:', e);
      }
    } else {
      console.error('🖼️ GALLERY DEBUG: ❌ jQuery or Slick not available');
    }
  }
  
  // Handle navigation image clicks
  navImages.forEach(nav => {
    nav.addEventListener('click', function() {
      const variantId = this.dataset.variantId;
      if (variantId) {
        // Find and select corresponding shade option
        const correspondingShade = document.querySelector(`[data-variant-id="${variantId}"]`);
        if (correspondingShade && correspondingShade.classList.contains('shade-option')) {
          correspondingShade.click();
        }
      }
    });
  });
  
  // Auto-select first available shade on page load
  const firstAvailableShade = document.querySelector('.shade-option:not([data-unavailable="true"])');
  console.log('🖼️ GALLERY DEBUG: First available shade:', firstAvailableShade);
  
  if (firstAvailableShade) {
    console.log('🖼️ GALLERY DEBUG: Auto-clicking first shade');
    firstAvailableShade.click();
  } else {
    console.warn('🖼️ GALLERY DEBUG: ⚠️ No shade options found - might not be a variant-based product');
    console.log('🖼️ GALLERY DEBUG: Checking if images are visible without variant selection...');
    
    // If no shade selector, ensure first image is visible
    if (productImages.length > 0) {
      productImages[0].style.display = 'block';
      console.log('🖼️ GALLERY DEBUG: ✅ Manually showing first image');
    }
  }
  
  console.log('🖼️ GALLERY DEBUG: ========================================');
  console.log('🖼️ GALLERY DEBUG: Initialization complete');
  console.log('🖼️ GALLERY DEBUG: ========================================');
});

// Utility function to get shade color from CSS variable
function getShadeColor(shadeName) {
  const cssVar = `--shade-${shadeName.toLowerCase().replace(/\s+/g, '-')}`;
  return getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();
}

// Export for potential external use
window.HairExtensionProduct = {
  switchToVariant: function(variantId) {
    const option = document.querySelector(`[data-variant-id="${variantId}"]`);
    if (option) {
      option.click();
    }
  },
  
  getSelectedShade: function() {
    const selected = document.querySelector('.shade-option.selected');
    return selected ? selected.dataset.shadeName : null;
  }
};
